import { render } from "preact";
import { useRef } from "preact/hooks";
import type { ContentConfig } from "../shared/types.js";
import { trackImpression } from "../shared/tracking.js";
import { ContentForm } from "./content-form.js";
import css from "../styles/tailwind.css?inline";

function ContentRoot({ config }: { config: ContentConfig }) {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} class="max-w-[520px] mx-auto bg-theme-card border border-theme-border rounded-theme font-theme shadow-[0_1px_3px_rgba(0,0,0,0.08)]">
      <ContentForm config={config} containerRef={containerRef} />
    </div>
  );
}

export function renderContent(hostEl: HTMLElement, config: ContentConfig): void {
  let shadow = hostEl.shadowRoot;
  if (shadow) {
    shadow.innerHTML = "";
  } else {
    shadow = hostEl.attachShadow({ mode: "open" });
  }

  const style = document.createElement("style");
  style.textContent = css;
  shadow.appendChild(style);

  const root = document.createElement("div");
  root.style.fontFamily = "system-ui, -apple-system, sans-serif";
  shadow.appendChild(root);

  render(<ContentRoot config={config} />, root);

  (hostEl as any).__fvUnmount = () => render(null, root);
  if (!config.preview) {
    trackImpression(config.embedApiUrl, config.formId, config.embed, config.attribution, hostEl);
  }
}
